/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AreaScope } from './areaScope.model';


export interface CreateToDtsrcAreaDto { 
    jpv: boolean;
    katuzeKod: number;
    katuzeNazev?: string;
    requested: boolean;
    scope: AreaScope;
}
export namespace CreateToDtsrcAreaDto {
}


